import { z } from "zod"

import { ethereumAddress } from "../base"

const tokenItem = z.object({
  name: z.string(),
  symbol: z.string(),
  address: ethereumAddress,
  decimals: z.number(),
  isWhitelisted: z.boolean(),
  isSwapToken: z.boolean(),
  isBribeToken: z.boolean(),
  tags: z.array(z.string()),
  priceUsd: z.string(),
})

export const tokenResponseSchema = z.record(z.string(), tokenItem)

export type TokenResponse = z.infer<typeof tokenResponseSchema>
export type TokenResponseItem = TokenResponse[number]
